import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { User } from '../roles';


const API_USERS_URL = `${environment.apiUrl}/auth`;

@Injectable({
  providedIn: 'root',
})
export class AuthHTTPService {
  constructor(private http: HttpClient) {}

  getAllUsers(): Observable<User[]> {
    return this.http.get<User[]>(API_USERS_URL);
  }

  login(credentials: string): Observable<any> {
    const notFoundError = new Error('Not Found');
    if (!credentials) {
      return of(notFoundError);
    }
    return this.http.post<any>(`/api/auth/login`, credentials).pipe(
      map((result: User) => {
        if (!result) {
          return notFoundError;
        }
        const auth = new User(result);
        auth.token = result.token;
        auth.refreshtoken = result.refreshtoken;
        return auth;
      })
    );
  }
  forgotPassword(email: string): Observable<boolean> {
    return this.http.post<boolean>(`${API_USERS_URL}/forgot-password`, {
      email,
    });
  }
  
  refreshToken(refreshToken: string, token: string): Observable<any> {
    return this.http.post<any>(`/api/auth/refresh-token`, {
      Refresh_token: refreshToken,
      Access_token: token,
      Expires_in: 20,
    });
  }
  
  getUserByToken(result: any): Observable<User> {
    const auth = new User(result);
        auth.token = result.token;
        auth.refreshtoken = result.refreshtoken;
        auth.expires = result.expires;
        auth.email = result.email;
        auth.emailConfirmed = result.emailConfirmed;
        auth.firstName = result.firstName;
        auth.isSuccess = result.isSuccess;
        auth.phoneNumber = result.phoneNumber;
        auth.phoneNumberConfirmed = result.phoneNumberConfirmed;
        auth.userName = result.userName;
        auth.verifyChoice = result.verifyChoice;
       return of(auth);
  }
  }


